const Types = {
    SEARCH_REQUEST: '@logs/SEARCH_REQUEST',
    SEARCH_SUCCESS: '@logs/SEARCH_SUCCESS',
    SEARCH_FAILURE: '@logs/SEARCH_FAILURE',
    REGISTER_REQUEST: '@logs/REGISTER_REQUEST',
    REGISTER_SUCCESS: '@logs/REGISTER_SUCCESS',
    REGISTER_FAILURE: '@logs/REGISTER_FAILURE',
};

export default Types;